import Vue from "vue";
import VueRouter from "vue-router";
import Router from "vue-router";
Vue.use(VueRouter);
Vue.use(Router);
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

const routesP = [

  {
    path: "/Index/Index",
    redirect: `/Index`,
  },
  {
    path: "/",
    redirect: `/Index`,
  },
  {
    path: "/",
    name: "home",
    component: () => import("./views/pc/Home"),
    children: [
      {
        path: '/Index',//首页
        name: 'Index',
        component: () => import("./views/pc/Index"),
        meta: {
          alive: true,
        },
      },
      {
        path: '/pc/Login',//首页
        name: 'Index',
        component: () => import("./views/pc/Admin/Login"),
        meta: {
          alive: true,
        },
      },
      {
        path: '/pc/Index',//首页
        name: 'Index',
        component: () => import("./views/pc/Admin/productlist"),
        meta: {
          alive: false,
        },
      },
      {
        path: '/pc/AddProduct',//首页
        name: 'Index',
        component: () => import("./views/pc/Admin/AddProduct"),
        meta: {
          alive: false,
        },
      },
      {
        path: '/pc/Details',//首页
        name: 'Index',
        component: () => import("./views/pc/Admin/ProductDetail"),
        meta: {
          alive: false,
        },
      },
    ],
  },
];

const routesM = [
  {
    path: "/Index/Index",
    redirect: `/Index`,
  },
  {
    path: "/",
    redirect: `/Index`,
  },
  {
    path: "/",
    name: "Index",
    component: () =>
      import(/* webpackChunkName: “about” */ "./views/m/Index.vue"),
  },
  {
    path: '/Index',
    name: 'home',
    component: () => import('./views/m/Home'),
    children: [
      {
        path: '/Index',
        name: 'Index',
        component: () => import('./views/m/Index'),
        meta: {
          alive: true,
        },
      }, 
     
    ],
  },
];

var routes = [];
if (
  navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
) {
  routes = routesM;
} else {
  routes = routesP;
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem("auserId"); // 检查是否有登录标识
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({
      path: '/pc/Login',
      query: { redirect: to.fullPath } // 保存用户想去的地方，以便在登录后重定向
    });
  } else {
    next(); // 确保一定要调用 next()
  }
});

export default router;
